import React from 'react';
import myxss from './myxss';
import { Heading } from 'rebass';
import { Label } from '@rebass/forms';
import helpersScreener from 'utils/helpers-screener';

const ComponentLabel = (props) => {
    //console.log('ComponentLabel', props)

    const hasRequiredLabel = (props.data.hasOwnProperty('required') && props.data.required === true && !props.read_only);
    const hasImage = (props.data.hasOwnProperty('label-image') ? props.data['label-image'] : false);
    let insert_html_sanitized = myxss.process(helpersScreener.insertPiping(props.data.label, props.all_questions, props.answers_by_form_element_name));
    /*console.log('insert_html', insert_html);
    if (hasRequiredLabel) {
        insert_html += <span style={{color: 'red', fontSize: '13px'}}>*</span>;
    }*/

    return (
        <Heading mt={3} mb={2} fontWeight='500' color='black' fontSize={[2,2,2]} className={props.className || ''}>
            {!props.data.static ? helpersScreener.showQuestionNumber(props.all_questions, props.data) : ''}
            <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{ __html: insert_html_sanitized }} />
            { hasImage && 
                <img src={hasImage} style={{maxWidth: '100%', margin: '16px 0 0 0'}} />
            }
            
        </Heading>
    );
};

export default ComponentLabel;
